import { parseHHmmToMs } from "@src/appV2/InterviewSettings/utils";
import { getStartOfDayForTimeZone } from "@src/appV2/ShiftBoard/util/convert";
import { addMilliseconds } from "date-fns";

export function createInterviewFormDataToTime(
  data: { interviewTime: { startTime: string; endTime: string }; date: Date },
  timeZone: string
) {
  const { interviewTime, date } = data;
  const localDate = getStartOfDayForTimeZone(date, timeZone);

  const startTimeOffset = parseHHmmToMs(interviewTime.startTime);
  const endTimeOffset = parseHHmmToMs(interviewTime.endTime);
  const startTime = addMilliseconds(localDate, startTimeOffset);
  const endTime = addMilliseconds(localDate, endTimeOffset);

  return {
    startTime,
    endTime,
  };
}
